import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=3b065a48&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
import style1 from "./Home.vue?vue&type=style&index=1&id=3b065a48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b065a48",
  null
  
)

export default component.exports